import {
  usePlanAccountDetail,
  usePlanAccounts,
  usePlanAccountsAll,
} from '@/core/domain/enterprise/PlanAccounts/PlanAccounts.hooks';
import { ListPlanAccountsQuery } from '@/core/domain/enterprise/PlanAccounts/PlanAccounts.types';
import { SelectProps } from 'antd';
import { useState } from 'react';
import InfiniteSelect from '@/components/_common/InfiniteSelect';
import { flatInfiniteData } from '@/utils/request/flatInfiniteData';
import { useDebounce } from '@/hooks';
import { DefaultOptionType } from 'antd/lib/select';

type Props = SelectProps & {
  queryFilter?: ListPlanAccountsQuery;
};

const PlanAccountsSelect: React.FC<Props> = ({ queryFilter, ...props }) => {
  const [searchValue, setSearchValue] = useState<string>();
  const search = useDebounce(searchValue);

  const { data, isLoading, hasNextPage, fetchNextPage } = usePlanAccounts(
    {
      description: search,
      ...queryFilter,
    },
    props.mode !== 'multiple',
  );
  const dataItems = flatInfiniteData(data);

  const { data: allData, isLoading: allIsLoading } = usePlanAccountsAll(
    {
      description: search,
      ...queryFilter,
    },
    props.mode === 'multiple',
  );
  const alldataItems = flatInfiniteData(allData);

  const itemsToBeListed =
    props.mode === 'multiple'
      ? [
          {
            id: 0,
            description:
              props.value?.length === alldataItems.length
                ? 'Remover seleção'
                : 'Selecionar todos',
          },
          ...alldataItems,
        ]
      : dataItems;

  const { data: detail } = usePlanAccountDetail(
    props.mode !== 'multiple' ? props.value : undefined,
  );

  const options =
    detail && !itemsToBeListed?.find((item) => item.id === detail.id)
      ? [...(itemsToBeListed || []), detail]
      : itemsToBeListed;

  const planAccountOptions = options?.map((cur) => ({
    value: cur.id,
    label: cur.description,
  }));

  function handleChange(
    value: number[],
    option: DefaultOptionType | DefaultOptionType[],
  ) {
    if (Array.isArray(value) && value.includes(0) && props.onChange) {
      if (value.includes(0)) {
        props.onChange(
          alldataItems.map((planAccount) => planAccount.id),
          alldataItems.map((planAccount) => ({
            value: planAccount.id,
            label: planAccount.description,
          })),
        );
      }

      if (value.length === alldataItems.length + 1) {
        props.onChange([], []);
      }
    } else {
      if (props.onChange) {
        props.onChange(value, option);
      }
    }
  }

  return (
    <InfiniteSelect
      fetchNextPage={fetchNextPage}
      hasNextPage={hasNextPage}
      loading={isLoading || allIsLoading}
      options={planAccountOptions}
      showSearch
      searchValue={searchValue}
      filterOption={false}
      onSearch={setSearchValue}
      {...props}
      onChange={handleChange}
    />
  );
};

export default PlanAccountsSelect;
